$('.search-music-results').delegate('.file-image, .file-preview, .file-listen, .file-read, .file-tif, .file-pdf', 'click', function (e) {
  e.preventDefault();
  const filename = $(this).data('filename');
  const idHymn = $(this).data('id');
  const idSong = $(this).data('idSong');
  const type = $(this).data('type');

  $.post(urlLogFileActivity, {
    filename,
    idHymn,
    id: idSong,
    type

  }, (data) => {

  });
});

$('.search-music-results').delegate('.file-tif, .file-pdf', 'click', function (e) {
  e.preventDefault();
  const url = $(this).attr('href');

  document.cookie = 'fileDownload=; Max-Age=0';

  $.fileDownload(url, {
    successCallback(url) {},
    failCallback(responseHtml, url) {
      toastr.error(__('Oops! It looks like that file is currently unavailable. Don\'t worry, the Member Publisher has been notified and a fix is on the way.'));
    }
  });

  return false;
});
